import client from './client'

export const fetchSettings = async () => {
  const response = await client.get('/settings')
  return response.data
}

export const putSettings = async (settings: any, token: string) => {
  const response = await client.put('/settings', settings, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})
  return response.data
}


